import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import * as R from "ramda";

import useLinkedinAuth from "../../../hooks/social/useLinkedinAuth";
import {
  connectUserSocialAccount,
  disconnectUserSocialAccount
} from "../../../store/actions/user";
import linkedinFeed from "../../../assets/linkedin-feed.svg";

import Account from "./Account";
import FacebookAccount from "./FacebookAccount";

import styled from "styled-components/macro";

const Accounts = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const UserSocialAccounts = ({ accounts = {} }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isLoadingMultiposting = useSelector(
    R.path(["user", "socialAccounts", "loading"])
  );

  const connectToFacebook = React.useCallback(
    ({ access_token, id }) => {
      dispatch(
        connectUserSocialAccount({
          access_token,
          page_id: id,
          provider: "facebook"
        })
      );
    },
    [dispatch]
  );

  const connectToLinkedin = React.useCallback(
    code => {
      dispatch(
        connectUserSocialAccount({
          code,
          provider: "linkedin",
          redirect_uri: process.env.REACT_APP_LI_REDIRECT_URL
        })
      );
    },
    [dispatch]
  );

  const linkedinAuth = useLinkedinAuth(connectToLinkedin);

  function disconnectFromAccount(provider) {
    dispatch(disconnectUserSocialAccount(provider));
  }

  return (
    <div>
      <h1>{t("opportunity:wizard.multiposting.titleJob")}</h1>
      <p>{t("company:socialMedia.description")}</p>
      <Accounts>
        <Account
          provider="linkedin"
          logo={linkedinFeed}
          account={accounts["linkedin"]}
          onConnect={linkedinAuth}
          onDisconnect={() => disconnectFromAccount("linkedin")}
          isLoading={isLoadingMultiposting === "linkedin"}
          isDisabled={
            isLoadingMultiposting && isLoadingMultiposting !== "linkedin"
          }
          connectedTo={
            accounts.linkedin && {
              name: `${R.path(
                ["linkedin", "localizedFirstName"],
                accounts
              )} ${R.path(["linkedin", "localizedLastName"], accounts)}`
            }
          }
        />
        {false && (
          <FacebookAccount
            account={accounts["facebook"]}
            onConnect={connectToFacebook}
            onDisconnect={() => disconnectFromAccount("facebook")}
            isLoading={isLoadingMultiposting === "facebook"}
            isDisabled={
              isLoadingMultiposting && isLoadingMultiposting !== "facebook"
            }
          />
        )}
      </Accounts>
    </div>
  );
};

export default UserSocialAccounts;
